const GetEOPDConfirmedStatusName = (id) => {
    switch (id) {
        case 0: { return "Pending" }
        case 1: { return "Rejected" }
        case 2: { return "InTheCabin" }
        case 3: { return "Completed" }
        case 4: { return "Absent" }
    }
}

const GetEOPDConfirmedStatus = {
    GetEOPDConfirmedStatus: [
        { Id: 0, Name: "Pending" },
        { Id: 1, Name: "Rejected" },
        { Id: 2, Name: "InTheCabin" },
        { Id: 3, Name: "Completed" },
        { Id: 4, Name: "Absent" },
    ]
}
const EOPDConfirmedStatusBg = (id) => {
    switch (id) {
        case 0: { return "bg-orange-400" }
        case 1: { return "bg-red-400" }
        case 2: { return "bg-blue-400" }
        case 3: { return "bg-green-400" }
        case 4: { return "bg-gray-400" }
    }
}

const EOPDConfirmedStatusText = (id) => {
    switch (id) {
        case 0: { return "text-orange-600" }
        case 1: { return "text-red-600" }
        case 2: { return "text-blue-600" }
        case 3: { return "text-green-600" }
        case 4: { return "text-gray-600" }
    }
}
export { GetEOPDConfirmedStatusName, GetEOPDConfirmedStatus, EOPDConfirmedStatusBg, EOPDConfirmedStatusText }
